export default __webpack_public_path__ + "static/media/energiemonitoring.faefba46.webp";